import { NodeModel } from '@minoru/react-dnd-treeview';
import { WorkshiftSchedulingsIds } from '../../models/copy-paste/CopyPaste';
import {
    WorkshiftSchedulingModel,
    WorkshiftsListModel,
} from '../../models/workshifts/workshif-scheduling/workshiftSchedulingList.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    workshiftShedulingList: WorkshiftsListModel;
    getWorkshiftScheduling: (
        date: string | number,
        employeeID: string | number,
        workshiftShedulingList: WorkshiftsListModel
    ) => WorkshiftSchedulingModel | undefined;
    openCopyWorkshiftsSchedulings: (
        copyRanges: WorkshiftSchedulingsIds[],
        workshifts: WorkshiftSchedulingModel[]
    ) => void;
};

export const controllerCopyWorkshiftSchedulings = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    workshiftShedulingList,
    getWorkshiftScheduling,
    openCopyWorkshiftsSchedulings,
}: Props) => {
    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);

    let dates = getDatesBetweenDates(initDate, lastDate);

    let copyRanges = [];
    let workshifts: WorkshiftSchedulingModel[] = [];
    let workshiftsFloating: WorkshiftSchedulingModel[] | undefined = [];

    for (let emp = 0; emp < selectedEmployees.length; emp++) {
        let workshiftsByEmployee: { workshiftSchedulingsIds: number[] } = {
            workshiftSchedulingsIds: [],
        };

        for (let date = 0; date < dates.length; date++) {
            let workshif = getWorkshiftScheduling(
                dates[date],
                selectedEmployees[emp].id,
                workshiftShedulingList
            );

            if (workshif?.workshift?.isFloating) {
                workshiftsFloating.push(workshif);
            }

            if (workshif) {
                workshifts.push(workshif);
                workshiftsByEmployee.workshiftSchedulingsIds.push(workshif.id);
            } else {
                workshifts.push({} as WorkshiftSchedulingModel);
                workshiftsByEmployee.workshiftSchedulingsIds.push(0);
            }
        }

        copyRanges.push(workshiftsByEmployee);
    }

    let existFloating = workshiftsFloating
        ?.map((w) => w.workshift?.isFloating)
        .includes(true);

    if (
        initDate &&
        lastDate &&
        selectedEmployees.length > 0 &&
        workshifts.length > 0 &&
        !existFloating
    ) {
        openCopyWorkshiftsSchedulings(copyRanges, workshifts);
    }
};
